import {createHelpers} from 'vuex-map-fields';

export const GYNE_FORM_STATE = 'gyneForm/STATE';
export const GET_GYNE_FORM_FIELDS = 'getGyneFormFields';
export const SET_GYNE_FORM_FIELDS = 'setGyneFormFields';

export const MUTATE_CLEAR_GYNE_FORM_STATE = 'gyneForm/CLEAR_STATE';
export const MUTATE_SET_GYNE_FORM_FIELD_VALUE = 'gyneForm/SET_GYNE_FORM_FIELD_VALUE';
export const MUTATE_INIT_GYNE_FORM_FIELD_VALUES = 'gyneForm/INIT_GYNE_FORM_FIELD_VALUES';


const {getGyneFormFields, setGyneFormFields} = createHelpers({
  getterType: GET_GYNE_FORM_FIELDS,
  mutationType: SET_GYNE_FORM_FIELDS,
});

const state = {
  service: null,
  admissionDate: null,
  admissionRoom: null,
  category: null,
  condition: null,
  categoryLaterality: null,
  operation: null,
  approach: null,
  procedure: null,
  operationLaterality: null,
  hysterectomy: null,
  dischargeDate: null,
  status: null,
  Id: null
};

const getters = {
  [GYNE_FORM_STATE]: (state) => state,
  getGyneFormFields
};

const mutations = {
  [MUTATE_CLEAR_GYNE_FORM_STATE]: (state) => {
    const keys = Object.keys(state);
    for(let key of keys) {
      state[key] = null;
    }
  },
  [MUTATE_SET_GYNE_FORM_FIELD_VALUE]: (state, {key, value}) => {
    if(state[key] !== undefined) {
      state[key] = value
    }
  },
  [MUTATE_INIT_GYNE_FORM_FIELD_VALUES]: (state, payload) => {
    const keys = Object.keys(state);
    for(let key of keys) {
      state[key] = payload[key];
    }
  },
  setGyneFormFields
};


export default {
  state,
  getters,
  mutations
}